
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 43 41","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26.7 39.291l-11.143.867V1.898l7.356-.858L26.7.598v38.693z","fill":"#FFD250"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M2.929 9.207v29.745l37.143-.626-.632-29.119H2.93zM.7 3.259v5.948h41.6l-.885-5.424L.7 3.26z","stroke":"#231F20"}}),_c('path',{attrs:{"d":"M5.173 12.182V34.49M17.058 2.515v35.693","stroke":"#231F20"}})])
          )
        }
      }
    